import React, { useContext, useState } from 'react';
import CardCommon from '@op/components/CardCommon';
import { lineIcon, tableIcon } from '@op/constants/chart';
import { useIntl } from 'umi';
import { LanguageType } from '@op/types/common';
import { FilterContext } from '../../context';
import TopicPerformanceTable from './TopicPerformanceTable';
import TopicPerformanceLine from './TopicPerformanceLine';
import './index.scss';

export default function TopicPerformance(props: any) {
  const { isTopicSentiment } = props;
  const [language, setLanguage] = useState<LanguageType>('origin');
  const { filter, topicLevel, gameInfo } = useContext(FilterContext);
  const { formatMessage } = useIntl();
  const [chartType, setChartType] = useState<'table' | 'line'>('table');

  return (
    <CardCommon
      className="dbo-topic-performance-wrapper"
      operations={[tableIcon, lineIcon]}
      defaultOperation={chartType}
      logBtnId="TopicPerformance"
      title={formatMessage({ id: 'Topic Performance' })}
      handleOperationsOnClick={(value: any) => {
        setChartType(value.symbol);
      }}
    >
      {chartType === 'table' ? (
        <TopicPerformanceTable
          language={language}
          setLanguage={setLanguage}
          isTopicSentiment={isTopicSentiment}
        />
      ) : (
        <TopicPerformanceLine
          topicLevel={topicLevel}
          filter={filter}
          language={language}
          setLanguage={setLanguage}
        />
      )}
    </CardCommon>
  );
}
